export default "__VITE_ASSET__BnBOOqCe__"